var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity-content auto-rebalance-success" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "activity-details" }, [
      _c("div", { staticClass: "detail-item" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Yüklenen Tutar:")]),
        _vm._v(" "),
        _c("span", { staticClass: "value success" }, [
          _vm._v(
            _vm._s(_vm.formatPrice(_vm.activity.payload.rechargeAmount)) + " TL"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-item" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Önceki Bakiye:")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(
            _vm._s(_vm.formatPrice(_vm.activity.payload.oldAmount)) + " TL"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-item" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Yeni Bakiye:")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(
            _vm._s(_vm.formatPrice(_vm.activity.payload.newAmount)) + " TL"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-item" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Hedef Bakiye:")]),
        _vm._v(" "),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.formatPrice(_vm.activity.payload.upTo)) + " TL"),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "activity-header" }, [
      _c("span", { staticClass: "material-icons success-icon" }, [
        _vm._v("account_balance_wallet"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "activity-title" }, [
        _vm._v("Otomatik Bakiye Yükleme Başarılı"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }